import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAries = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 36,
	height: 36,
	viewBox: "0 0 36 36",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8.27872 17.6382C6.75957 16.556 6 14.9063 6 12.689C6 9.36299 8.66225 6.66675 11.9463 6.66675C15.2304 6.66675 18 9.71877 18 13.0448C18 9.71877 20.7696 6.66675 24.0537 6.66675C27.3377 6.66675 30 9.36299 30 12.689C30 14.9063 29.2404 16.556 27.7213 17.6382M18 10.6667V29.3333",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgAries;
